import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

import DarkTheme from 'common/config/theme/app/dark'

import { THEMES } from 'common/constants/themes'
import { useLocalStorage } from 'core/hooks/storage'

function AppThemeProvider(props) {
  // Destructure
  const { children } = props

  const [theme] = useLocalStorage('theme', 'dark')

  return <ThemeProvider theme={THEMES?.[theme] ? THEMES?.[theme] : DarkTheme}>{children}</ThemeProvider>
}

export default AppThemeProvider

// Proptypes Validation
AppThemeProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
}
